import React, {useEffect, useState} from "react";
import {Layout} from "../components/common/Layout";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import classNames from "./Leads.module.css";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Button from "@mui/material/Button";
import {Stack} from "@mui/material";
import {AddUserModal} from "../components/user/AddUserModal";
import {useMutation, useQuery} from "@apollo/client";
import {GET_USERS} from "../api/user/getUsers";
import {DELETE_USER} from "../api/user/deleteUser";
import {ErrorMessage} from "../components/common/ErrorMessage";
import {DEMOTE_USER} from "../api/user/demoteUser";
import {PROMOTE_USER} from "../api/user/promoteUser";

export const Users = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const {loading: isFetchLoading, data, refetch} = useQuery(GET_USERS);
    const [deleteUser, {loading: isDeleteLoading, error: deleteError}] = useMutation(DELETE_USER)
    const [demoteUser, {loading: isDemoteLoading, error: demoteError}] = useMutation(DEMOTE_USER)
    const [promoteUser, {loading: isPromoteLoading, error: promoteError}] = useMutation(PROMOTE_USER)

    const onDelete = async (id: string) => {
        const {errors} = await deleteUser({variables: {deleteUserId: id}})

        if (errors === undefined || errors.length === 0) {
            refetch()
        }
    }

    const onPromote = async (id: string) => {
        const {errors} = await promoteUser({variables: {promoteUserId: id}})

        if (errors === undefined || errors.length === 0) {
            refetch()
        }
    }

    const onDemote = async (id: string) => {
        const {errors} = await demoteUser({variables: {demoteUserId: id}})

        if (errors === undefined || errors.length === 0) {
            refetch()
        }
    }

    useEffect(() => {
        if (deleteError) setErrorMessage(deleteError.message)
        else if (demoteError) setErrorMessage(demoteError.message)
        else if (promoteError) setErrorMessage(promoteError.message)
    }, [deleteError?.message, demoteError?.message, promoteError?.message])

    const isLoading = isFetchLoading || isDeleteLoading || isDemoteLoading || isPromoteLoading

    return (
        <Layout title="Users" showHeader showMenu isLoading={isLoading}>
            <Stack alignItems="flex-end" marginBottom="2rem">
                <Button variant="contained" color="success" onClick={() => setIsModalOpen(true)}>
                    Add New User
                </Button>
            </Stack>

            {data !== undefined && (
                <TableContainer component={Paper}>
                    <Table className={classNames.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Role</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.getStaffMembers.map((row) => (
                                <TableRow key={row.id} className={classNames.row}>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                    <TableCell>{row.role}</TableCell>
                                    <TableCell>
                                        <Stack direction="row" gap="1rem" marginTop="1rem">
                                            <Button
                                                onClick={() => onDelete(row.id)}
                                                color="error"
                                                size="small"
                                                variant="contained"
                                            >
                                                Delete
                                            </Button>
                                            {row.role === 'ADMIN' ? (
                                                <Button
                                                    onClick={() => onDemote(row.id)}
                                                    color="info"
                                                    size="small"
                                                    variant="contained"
                                                >
                                                    Demote
                                                </Button>
                                            ) : (
                                                <Button
                                                    onClick={() => onPromote(row.id)}
                                                    color="info"
                                                    size="small"
                                                    variant="contained"
                                                >
                                                    Promote
                                                </Button>
                                            )}
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            {isModalOpen && (
                <AddUserModal
                    onClose={(shouldRefetch: boolean) => {
                        if (shouldRefetch) refetch()
                        setIsModalOpen(false)
                    }}
                />
            )}

            <ErrorMessage
                handleClose={() => setErrorMessage('')}
                isOpen={errorMessage !== ''}
                message={errorMessage}
            />
        </Layout>
    )
}
